module.exports = __webpack_public_path__ + "static/media/Assessments.dee9b76b.svg";